export const SEARCH_HISTORY_KEY = 'd88_global_search_history';
export const SEARCH_HISTORY_MAX = 8;

export function loadSearchHistory(): string[] {
  try {
    const raw = localStorage.getItem(SEARCH_HISTORY_KEY);
    const parsed = raw ? (JSON.parse(raw) as unknown) : [];
    return Array.isArray(parsed) ? parsed.map(String).filter(Boolean).slice(0, SEARCH_HISTORY_MAX) : [];
  } catch {
    return [];
  }
}

export function persistSearchHistory(entries: string[]): void {
  try {
    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(entries.slice(0, SEARCH_HISTORY_MAX)));
  } catch {
    // ignore
  }
}

export function addSearchHistoryEntry(query: string, prev: string[]): string[] {
  const q = query.trim();
  if (q.length < 2) return prev;
  const next = [q, ...prev.filter((p) => p.toLowerCase() !== q.toLowerCase())].slice(0, SEARCH_HISTORY_MAX);
  persistSearchHistory(next);
  return next;
}

export function clearSearchHistory(): void {
  try {
    localStorage.removeItem(SEARCH_HISTORY_KEY);
  } catch {
    // ignore
  }
}
